import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/dev/Dev.js"
import unitJobs from "@frog/source/data/unitJobs.js"
import games from "@frog/source/data/games/index.js"

import "@frog/source/views/components/UnitHealthBar.less"

const MAXIMUM_HP = 30
const HP_PER_SEGMENT = 10

export default class UnitHealthBar {
    render() {
        if(this.props.unit?.properties?.includes("no healthbar")) return
        if(this.props.isHidden == true) return
        if(this.props.unit.affiliation == "none") return
        if(this.props.unit.isHidingHealthbar == true) return
        return (
            <div class="UnitHealthBar" style={this.style} affiliation={this.props.unit.affiliation}>
                {this.fill}
                {this.omegafill}
                {this.borders}
            </div>
        )
    }
    get style() {
        return {
            "width": (this.props.unit.maxhealth / 10) + "em"
        }
    }
    get color() {
        // if(this.props.unit.affiliation == "good") return "#c33a00"
        // if(this.props.unit.affiliation == "orange") return "#f3b51c"
        // if(this.props.unit.affiliation == "blue") return "#597189"
        // if(this.props.unit.affiliation == "purple") return "#8f5ba2"
        // return "#A29368"
    }
    get fill() {
        return (
            <div class="Fill" isBig={this.props.unit.maxhealth > 100} style={{
                "width": Math.max(0, this.props.unit.health / this.props.unit.maxhealth) * 100 + "%",
                // "background-color": this.col`or
            }}/>
        )
    }
    get omegafill() {
        if(App.options.disableActionUI == true) return
        if(this.props.omegaunit != undefined) {
            return (
                <div class="OmegaFill" color={this.props.unit.health <= this.props.omegaunit.health ? "hurt" : "heal"} style={{
                    "width": (Math.abs(this.props.unit.health - this.props.omegaunit.health) / this.props.unit.maxhealth) * 100 + "%",
                    "left": (Math.min(this.props.unit.health, this.props.omegaunit.health) / this.props.unit.maxhealth) * 100 + "%",
                }}/>
            )
        }
    }
    get borders() {
        const borders = []
        if(this.props.unit.maxhealth / HP_PER_SEGMENT >= this.props.maxsegments) return
        for(let i = 0; i < this.props.unit.maxhealth / HP_PER_SEGMENT; i += 1) {
            borders.push(
                <div class="Border"/>
            )
        }
        return (
            <div class="Borders">
                {borders}
            </div>
        )
    }
}
